import { computed, readonly } from 'vue';
import { defineStore } from 'pinia';
import { useAppPage } from "@/composables/useAppPage";
import Swal from 'sweetalert2';

export const useAuthStore = defineStore('auth', () => {
    const TOKEN_EAUTH_KEY = 'eauth_token';

    const {
        user: userProps,
        personas: personasProps,
        notificacoesNaoLidasCount: notificacoesNaoLidasCountProps,
        eauthToken
    } = useAppPage();

    const user = readonly(computed(() => userProps.value || null));
    const isAuthenticated = readonly(computed(() => !!user.value));

    const personas = readonly(computed(() => personasProps.value || []));

    const notificacoesNaoLidasCount = computed(() => notificacoesNaoLidasCountProps.value ?? 0);

    function login() {
        window.location.href = route('login');
    }

    async function logout() {
        const resp = await Swal.fire({
            text: 'Deseja mesmo sair da sua conta?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: 'var(--color-primary)',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        });

        if (!resp.isConfirmed) return;

        const apiUrl = process.env.MIX_EAUTH_API_URL;
        const eauthUrl = apiUrl ? `${apiUrl.replace(/\/$/, '')}/` : null;
        const token = localStorage.getItem(TOKEN_EAUTH_KEY);

        if (eauthUrl && token) {
            try {
                await fetch(`${eauthUrl}api/logout`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: 'application/json'
                    }
                });
            } catch {
                // O logout central deve continuar mesmo se a revogação falhar.
            }
        }

        localStorage.removeItem(TOKEN_EAUTH_KEY);

        if (eauthUrl) {
            window.location.href = `${eauthUrl}logout?redirect=${encodeURIComponent(route('logout'))}`;
        } else {
            window.location.href = route('logout');
        }
    }

    function setEauthToken() {
        const token = eauthToken.value;

        if (token) {
            localStorage.setItem(TOKEN_EAUTH_KEY, token);

            if (token && window.eauthWidget) {
                window.eauthWidget.setToken(token);
            }
        }
    }

    return {
        user,
        isAuthenticated,
        personas,
        notificacoesNaoLidasCount,
        login,
        logout,
        setEauthToken
    }
});
